import Logo from "@/components/layout/Logo";
import { useTranslation } from "react-i18next";

interface LoadingScreenProps {
  status: "splash" | "inline";
}

export default function LoadingScreen({ status }: LoadingScreenProps) {
  const { t } = useTranslation();

  if (status === "inline") {
    return (
      <output
        className="w-full flex-1 flex items-center justify-center gap-2 text-muted-foreground"
        aria-live="polite"
      >
        <span className="flex gap-1" aria-hidden="true">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="h-1 w-1 rounded-full bg-muted-foreground animate-bounce"
              style={{ animationDelay: `${i * 0.15}s`, animationDuration: "0.9s" }}
            />
          ))}
        </span>
        <span className="text-sm">{t("loading.loading")}</span>
      </output>
    );
  }

  return (
    <output
      className="w-full min-h-screen flex items-center justify-center text-muted-foreground"
      aria-live="polite"
      aria-label={t("loading.loading")}
    >
      <div className="flex flex-col items-center gap-8">
        <Logo className="h-10 w-auto animate-pulse" style={{ animationDuration: "2s" }} />
        <span className="text-xs tracking-widest uppercase text-muted-foreground/60">
          {t("loading.loading")}
        </span>
      </div>
    </output>
  );
}
